import { GuestQuantityDto } from '@wwt/entities/api/search-response'

export const defaultGuestQuantity: GuestQuantityDto = {
	adultsQuantity: 2,
	ageOfChildren: [],
	pets: []
}
